/** Тексты окна: Просьба разрешить боту писать. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.writeAccess.title": "Want a reminder from the bot?",
  "win.writeAccess.text":
    "The bot will message you when your storage is full or your streak is about to burn. Once a day at most.",
  "win.writeAccess.allow": "Allow",
  "win.writeAccess.decline": "Not now",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.writeAccess.title": "Напомнить через бота?",
  "win.writeAccess.text": "Бот напишет, когда склад полон или серия вот-вот сгорит. Не чаще раза в день.",
  "win.writeAccess.allow": "Разрешить",
  "win.writeAccess.decline": "Не сейчас",
};

const uk: Record<Key, string> = {
  "win.writeAccess.title": "Нагадати через бота?",
  "win.writeAccess.text": "Бот напише, коли склад повний або серія ось-ось згорить. Не частіше разу на день.",
  "win.writeAccess.allow": "Дозволити",
  "win.writeAccess.decline": "Не зараз",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
